import { useContext } from 'react';
import AnalyticsContext from '../../common/context/analytics';

export default function useAnalyticsContext() {
  const analytics = useContext(AnalyticsContext);
  return analytics;
}
